import * as Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import store from './VuexStore';

loadFonts()


const app = Vue.createApp(App);

app.use(store);
app.use(router);
app.use(vuetify);
app.mount('#app');
